var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16.5C28.5 16.8978 28.342 17.2794 28.0607 17.5607C27.7794 17.842 27.3978 18 27 18H5C4.60218 18 4.22064 17.842 3.93934 17.5607C3.65804 17.2794 3.5 16.8978 3.5 16.5C3.5 16.1022 3.65804 15.7206 3.93934 15.4393C4.22064 15.158 4.60218 15 5 15H27C27.3978 15 27.7794 15.158 28.0607 15.4393C28.342 15.7206 28.5 16.1022 28.5 16.5ZM5 10H27C27.3978 10 27.7794 9.84196 28.0607 9.56066C28.342 9.27936 28.5 8.89782 28.5 8.5C28.5 8.10218 28.342 7.72064 28.0607 7.43934C27.7794 7.15804 27.3978 7 27 7H5C4.60218 7 4.22064 7.15804 3.93934 7.43934C3.65804 7.72064 3.5 8.10218 3.5 8.5C3.5 8.89782 3.65804 9.27936 3.93934 9.56066C4.22064 9.84196 4.60218 10 5 10ZM27 23H5C4.60218 23 4.22064 23.158 3.93934 23.4393C3.65804 23.7206 3.5 24.1022 3.5 24.5C3.5 24.8978 3.65804 25.2794 3.93934 25.5607C4.22064 25.842 4.60218 26 5 26H27C27.3978 26 27.7794 25.842 28.0607 25.5607C28.342 25.2794 28.5 24.8978 28.5 24.5C28.5 24.1022 28.342 23.7206 28.0607 23.4393C27.7794 23.158 27.3978 23 27 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.02ac60e836be35784c9c3830d80597e8.svg";
export { ForwardRef as ReactComponent };